// extracted by mini-css-extract-plugin
export default {"app":"L5x0Fp","scrollable":"aVF3iR","postPageApp":"Led6wX"};